import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import SentryDesktopHeader from '../components/sentry-desktop/SentryDesktopHeader';

const SentryDesktopLayout: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('sentry-desktop-mode');
    document.documentElement.classList.add('sentry-desktop-mode');

    return () => {
      document.body.classList.remove('sentry-desktop-mode');
      document.documentElement.classList.remove('sentry-desktop-mode');
    };
  }, []);

  return (
    <div className="sentry-desktop-shell">
      <SentryDesktopHeader />
      <main className="sentry-desktop-content">
        <Outlet />
      </main>
    </div>
  );
};

export default SentryDesktopLayout;
